import { CheckCircle } from '@phosphor-icons/react';
import aboutImage from '../../assets/about-tech.jpg';
import '../LandingPage.css';

const highlights = [
  'Client projects in healthcare, finance and e-commerce',
  'Our own product, ChatServe, live in Romania and Spain',
  'Work that runs from the first plan to support after launch',
];

function AboutSection() {
  return (
    <section id="about" className="about-section section" aria-labelledby="about-title">
      <div className="section-content">
        <div className="about-grid">
          <div className="about-image reveal">
            <img
              src={aboutImage}
              alt="Code on a developer's screen"
              className="tech-image"
              width={1200}
              height={600}
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="about-text reveal reveal-delay-1">
            <h2 id="about-title" className="section-title">
              Twenty years of building software for businesses
            </h2>
            <p>
              EFSoft is a software engineering company. Over more than 20 years
              we have built web applications in a wide range of technologies,
              for clients in healthcare, finance, e-commerce and other
              industries.
            </p>
            <ul className="check-list">
              {highlights.map((item) => (
                <li key={item}>
                  <CheckCircle className="check-list-icon" size={20} weight="fill" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
